export const normalizeArrayByField = <T>(array: T[], fieldName = 'id'): { [key: string ]: T } =>
  array.reduce(
    (acc, curItem) => ({
      ...acc,
      [curItem[fieldName]]: curItem,
    }),
    {}
  );
